export class PuntajePruebasDTO {
    constructor(
        public prueba: string,
        public valor: string
    ){}
}